import styled from 'styled-components';
import { primaryBoxButtonStyles } from '../../utils/styles';

const ButtonBox = styled.button`
  ${primaryBoxButtonStyles};
`;

export default ButtonBox;
